<div class="right-sidebar-skeleton">
  <div *ngIf="showStoreSkeleton" class="sidebar-creator-widget">
    <div *ngIf="showHeading" class="right-sidebar-skeleton__heading">
      <app-skeleton className="h-16 w-200 r-4 c-post"></app-skeleton>
    </div>
    <div class="sidebar-creator-list">
      <div
        *ngFor="let _ of cardIndices"
        class="right-sidebar-skeleton__item"
      >
        <app-skeleton className="h-100 w-100% r-20 c-post"></app-skeleton>
      </div>
    </div>
    <div *ngIf="showViewAllButtonSkeleton" class="right-sidebar-skeleton__view-all">
      <app-skeleton className="h-40 w-100% r-24 c-post"></app-skeleton>
    </div>
  </div>
  <div *ngIf="showAdSkeleton" class="right-sidebar-skeleton__ad">
    <app-skeleton className="h-500 w-100% r-20 c-post"></app-skeleton>
  </div>
</div>
